import { FaBook } from "react-icons/fa";
import { NotebookViewMain } from "../Components/NotebookViewMain";

export const NotebookModule = () => [
    {
        views: "PRIVATE", path: "/notebook", component: <NotebookViewMain />,
        roles: null, permissions: null, label: "Cuaderno", icon: <FaBook />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: true,
        isBlockedWhenLogged: false,
    },
];
